var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "navWrap",
      class: [_vm.getBdg(_vm.gray), _vm.getBdgTenant(_vm.gray)],
      staticStyle: { display: "flex" },
      style: { top: "0px", position: _vm.pos }
    },
    [
      _c(
        "div",
        { staticClass: "navCon clear" },
        [
          _c("u-connect-activation-alert"),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { display: "flex", "align-items": "center" } },
            [
              _c("el-col", { attrs: { span: 11, offset: 1 } }, [
                _c("div", {
                  staticClass: "logo",
                  on: {
                    click: function($event) {
                      _vm.privateMode ? null : _vm.redirectToHome()
                    }
                  }
                })
              ]),
              _vm._v(" "),
              !_vm.privateMode && _vm.isModeVisible()
                ? _c("el-col", { attrs: { span: 1 } }, [
                    _c(
                      "div",
                      {
                        staticClass: "onOff",
                        class: { on: _vm.mode == "on" },
                        on: { click: _vm.turn }
                      },
                      [
                        _c("div", { staticClass: "circle" }, [
                          _vm.mode == "off"
                            ? _c("span", [_vm._v("OFF")])
                            : _vm._e(),
                          _vm.mode == "on"
                            ? _c("span", [_vm._v("ON")])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text" }, [_vm._v("Mode")])
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.privateMode
                ? _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-end"
                      },
                      attrs: { span: 11 }
                    },
                    [
                      _c(
                        "el-menu",
                        {
                          staticClass: "el-menu-demo",
                          attrs: {
                            "default-active": _vm.activeIndexPage,
                            mode: "horizontal",
                            "text-color": "#003333",
                            "active-text-color": "#003333"
                          },
                          on: { select: _vm.handleNavigation }
                        },
                        [
                          !_vm.privateMode
                            ? _c("el-menu-item", { attrs: { index: "blog" } }, [
                                _vm._v("Blog")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isSignedIn && !_vm.privateMode
                            ? _c(
                                "el-submenu",
                                { attrs: { index: "user-account" } },
                                [
                                  _c("template", { slot: "title" }, [
                                    _vm._v("\n                Welcome "),
                                    _c("b", [_vm._v(_vm._s(_vm.firstName))])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-menu-item",
                                    { attrs: { index: "my-account" } },
                                    [_vm._v("My Account")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-menu-item",
                                    { attrs: { index: "logout" } },
                                    [_vm._v("Logout")]
                                  )
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isSignedIn && !_vm.privateMode
                            ? _c(
                                "el-menu-item",
                                { attrs: { index: "login" } },
                                [
                                  _c(
                                    "el-button",
                                    { staticClass: "menu-item-btn" },
                                    [_vm._v("Login")]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a262407", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a262407","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/topNav.vue
// module id = null
// module chunks = 